const WebflowSimulator = () => {
  const industries = [
    {
      // 2 flows share the same landing page
      // there is no vatFilter datapoint in the request,
      // but the presence of "vatFilter": true/false in the request body
      // determines which flow is triggered in HubSpot

      // LOCAL

      name: "HU-ASP-MIC-LOCAL/TEST/MRR/10000",
      description: "ÁFÁs, nem ÁFÁs flow lokális tesztelése (Scale + Alfa)",
      landingUrl:
        "https://vallalkozas.bookkeepie.com/hu/hu-asp-mic-local-test-mrr-10000",
      useExternal: true,
    },
    {
      name: "HU-ASP-MIC-LOCAL/TEST/MRR/S/10000",
      description: "Nem ÁFÁs flow lokális tesztelése (Scale)",
      landingUrl:
        "https://vallalkozas.bookkeepie.com/hu/hu-asp-mic-local-test-mrr-s-10000",
      useExternal: true,
    },
    {
      name: "HU-ASP-MIC-LOCAL/TEST/MRR/A/10000",
      description: "ÁFÁs flow lokális tesztelése (Alfa)",
      landingUrl:
        "https://vallalkozas.bookkeepie.com/hu/hu-asp-mic-local-test-mrr-a-10000",
      useExternal: true,
    },
    {
      name: "HU-ASP-GEN-LOCAL/TEST/EV-MINI/MRR/S/10000",
      description:
        "EV esetén - form-ban nincs Vezetéknév + Keresztnév (Nem ÁFÁs)",
      landingUrl:
        "https://vallalkozas.bookkeepie.com/hu/hu-asp-gen-local-test-ev-mini-mrr-s-10000",
      useExternal: true,
    },

    // DEVELOPMENT

    {
      name: "HU-ASP-MIC-DEV/TEST/MRR/10000",
      description: "ÁFÁs, nem ÁFÁs flow tesztelése DEV-en (Scale + Alfa)",
      landingUrl:
        "https://vallalkozas.bookkeepie.com/hu/hu-asp-mic-dev-test-mrr-10000",
      useExternal: true,
    },
    {
      name: "HU-ASP-MIC-DEV/TEST/MRR/S/10000",
      description: "Nem ÁFÁs flow tesztelése DEV-en (Scale)",
      landingUrl:
        "https://vallalkozas.bookkeepie.com/hu/hu-asp-mic-dev-test-mrr-s-10000",
      useExternal: true,
    },
    {
      name: "HU-ASP-MIC-DEV/TEST/MRR/A/10000",
      description: "ÁFÁs flow tesztelése DEV-en (Alfa)",
      landingUrl:
        "https://vallalkozas.bookkeepie.com/hu/hu-asp-mic-dev-test-mrr-a-10000",
      useExternal: true,
    },
    {
      name: "HU-ASP-GEN-DEV/TEST/EV-MINI/MRR/S/10000",
      description:
        "EV esetén - form-ban nincs Vezetéknév + Keresztnév (Nem ÁFÁs)",
      landingUrl:
        "https://vallalkozas.bookkeepie.com/hu/hu-asp-gen-dev-test-ev-mini-mrr-s-10000",
      useExternal: true,
    },

    // PRODUCTION

    {
      name: "HU-ASP-GEN-PROD/KATA-START/MRR/S/11500",
      description: "ÁLTALÁNOS - Kisvállalkozói KATA start 11 500 Ft / hó",
      landingUrl:
        "https://vallalkozas.bookkeepie.com/kisvallalkozoi-kata-start-altalanos",
      useExternal: true,
    },
    {
      name: "HU-ASP-GEN-PROD/KATA-MED/MRR/S/15000",
      description: "ÁLTALÁNOS - Közepes KATA csomag 15 000 Ft / hó",
      landingUrl: "https://vallalkozas.bookkeepie.com/kozepes-kata-altalanos",
      useExternal: true,
    },
    {
      name: "HU-ASP-GEN-PROD/EV-MINI/MRR/S/17250",
      description: "ÁLTALÁNOS - Egyéni vállalkozás mini 17 250 Ft / hó",
      landingUrl:
        "https://vallalkozas.bookkeepie.com/egyeni-vallalkozas-mini-altalanos",
      useExternal: true,
    },
    {
      name: "HU-ASP-GEN-PROD/FO-MINI/MRR/S/20700",
      description: "ÁLTALÁNOS - Főállású vállalkozói mini 20 700 Ft / hó",
      landingUrl:
        "https://vallalkozas.bookkeepie.com/foallas-vallalkozo-mini-altalanos",
      useExternal: true,
    },
    {
      name: "HU-ASP-GEN-PROD/EV-MED/MRR/20750",
      description: "ÁLTALÁNOS - Egyéni vállalkozás medium 20 750 Ft / hó",
      landingUrl:
        "https://vallalkozas.bookkeepie.com/egyeni-vallalkozas-medium-altalanos",
      useExternal: true,
    },
    {
      name: "HU-ASP-GEN-PROD/FO-MED/MRR/25900",
      description: "ÁLTALÁNOS - Főállású vállalkozói medium 25 900 Ft / hó",
      landingUrl:
        "https://vallalkozas.bookkeepie.com/foallas-vallalkozo-medium-altalanos",
      useExternal: true,
    },
    {
      name: "HU-ASP-GEN-PROD/KFT-MINI/MRR/S/34500",
      description: "ÁLTALÁNOS - Kft. MINI 34 500 Ft / hó",
      landingUrl:
        "https://vallalkozas.bookkeepie.com/kft-mini-csomag-altalanos-34500",
      useExternal: true,
    },
    {
      name: "HU-ASP-GEN-PROD/KFT-MINI/MRR/A/39900",
      description: "ÁLTALÁNOS - Kft. MINI 39 900 Ft / hó",
      landingUrl:
        "https://vallalkozas.bookkeepie.com/kft-mini-csomag-altalanos",
      useExternal: true,
    },
    {
      name: "HU-ASP-GEN-PROD/KFT-AFA-MED/MRR/A/59900",
      description: "ÁLTALÁNOS - Áfás Kft. medium csomag 59 900 Ft / hó",
      landingUrl:
        "https://vallalkozas.bookkeepie.com/afas-kft-medium-csomag-altalanos",
      useExternal: true,
    },
  ];

  const env = process.env.REACT_APP_ENV || "dev";
  let visibleIndustries = industries;

  switch (env) {
    case "local":
      visibleIndustries = industries.slice(0, 4);
      break;
    case "dev":
      visibleIndustries = industries.slice(4, 8);
      break;
    case "prod":
      visibleIndustries = industries.slice(8);
      break;
    default:
      visibleIndustries = industries;
      break;
  }

  const handleClick = (industry) => {
    if (industry.landingUrl) {
      window.open(industry.landingUrl, "_blank");
    }
  };

  return (
    <div
      style={{
        maxWidth: 900,
        margin: "60px auto",
        padding: "40px",
        fontFamily: "system-ui, -apple-system, sans-serif",
      }}
    >
      <h1 style={{ textAlign: "center", marginBottom: 16, fontSize: 32 }}>
        Webflow Simulator
      </h1>
      <p
        style={{
          textAlign: "center",
          color: "#666",
          marginBottom: 48,
          fontSize: 16,
        }}
      >
        Temporary page to simulate Webflow CTAs. Choose an industry to see the
        HubSpot form:
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
          gap: 24,
        }}
      >
        {visibleIndustries.map((industry, idx) => (
          <div
            key={idx}
            style={{
              border: "2px solid #e0e0e0",
              borderRadius: 12,
              padding: 24,
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              transition: "all 0.2s",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#1c32f3";
              e.currentTarget.style.boxShadow =
                "0 4px 16px rgba(28,50,243,0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#e0e0e0";
              e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";
            }}
            onClick={() => handleClick(industry)}
          >
            <h2 style={{ marginTop: 0, marginBottom: 12, fontSize: 20 }}>
              {industry.name}
            </h2>
            <p style={{ color: "#666", marginBottom: 16, fontSize: 14 }}>
              {industry.description}
            </p>
            <div
              style={{
                fontSize: 12,
                color: "#1c32f3",
                fontFamily: "monospace",
              }}
            >
              🔗 {industry.landingUrl}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WebflowSimulator;
